import { PaymentTypeLabel } from '../../types';
import { I18n, Store } from '../../wrappers';
import { EinvoiceService } from '../../services';
export class CashRegisterLocalizationSr {
    cashRegister;
    constructor(cashRegister) {
        this.cashRegister = cashRegister;
    }
    static availablePaymentTypes() {
        const noncashOnly = !!Store.get('tenant')?.venue?.settings.noncash_only;
        const einvoiceOnly = EinvoiceService.einvoiceOnly();
        const cashPaymentTypes = [PaymentTypeLabel.cash, PaymentTypeLabel.credit_card];
        const payments = einvoiceOnly
            ? [PaymentTypeLabel.invoice, PaymentTypeLabel.advance]
            : [
                ...(!noncashOnly ? cashPaymentTypes : []),
                PaymentTypeLabel.invoice,
                PaymentTypeLabel.advance,
                PaymentTypeLabel.check,
                PaymentTypeLabel.voucher,
                PaymentTypeLabel.mobile_money,
                PaymentTypeLabel.other_noncash,
            ];
        return payments.map(val => {
            return {
                key: val,
                display: I18n.t(`orders.payment_types.${val}`),
            };
        });
    }
}
const CashRegisterLocalizationSrStatic = CashRegisterLocalizationSr;
//# sourceMappingURL=CashRegisterLocalizationSr.js.map